(function () {
  if (window.__roroComingSoonInit) return;
  window.__roroComingSoonInit = true;

  const MODAL_ID = 'roro-coming-soon-modal';
  let modal;
  let lastFocus;

  function getModal() {
    if (modal) return modal;
    modal = document.getElementById(MODAL_ID);
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function setText(el, value) {
    if (!el) return;
    const text = (value || '').trim();
    if (!text) {
      el.textContent = '';
      el.hidden = true;
      return;
    }
    el.textContent = text;
    el.hidden = false;
  }

  function applyModalContent(trigger) {
    const el = getModal();
    if (!el) return;

    const eyebrowEl = el.querySelector('#roro-coming-soon-eyebrow');
    const titleEl = el.querySelector('#roro-coming-soon-title');
    const textEl = el.querySelector('#roro-coming-soon-desc');

    const hasCustom = trigger && trigger.dataset.roroComingSoonTitle;

    const eyebrow = hasCustom
      ? trigger.dataset.roroComingSoonEyebrow || ''
      : el.dataset.defaultEyebrow || '';
    const title = hasCustom
      ? trigger.dataset.roroComingSoonTitle || ''
      : el.dataset.defaultTitle || 'Coming soon!';
    const text = hasCustom
      ? trigger.dataset.roroComingSoonText || ''
      : el.dataset.defaultText || '';
    const accent = hasCustom
      ? trigger.dataset.roroComingSoonAccent === 'true'
      : el.dataset.defaultAccent === 'true';

    setText(eyebrowEl, eyebrow);
    setText(titleEl, title);
    setText(textEl, text);

    if (titleEl) {
      titleEl.classList.toggle('roro-coming-soon__title--orange', accent);
    }

    if (text && textEl) {
      el.setAttribute('aria-describedby', 'roro-coming-soon-desc');
    } else {
      el.removeAttribute('aria-describedby');
    }
  }

  function openModal(trigger) {
    const el = getModal();
    if (!el) return;
    applyModalContent(trigger);
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('roro-coming-soon-open');
    const okBtn = el.querySelector('.roro-coming-soon__ok');
    if (okBtn instanceof HTMLElement) {
      okBtn.focus();
    } else {
      const closeBtn = el.querySelector('.roro-coming-soon__close');
      if (closeBtn instanceof HTMLElement) closeBtn.focus();
    }
  }

  function closeModal() {
    const el = getModal();
    if (!el) return;
    el.hidden = true;
    document.body.classList.remove('roro-coming-soon-open');
    if (lastFocus instanceof HTMLElement) lastFocus.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getModal);
  } else {
    getModal();
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-roro-coming-soon]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.target.closest('[data-roro-coming-soon-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const el = getModal();
    if (el && !el.hidden) closeModal();
  });
})();
